/** Name fields of an invoice data record, shared by every view DTO that carries them. */
type InvoiceNameParts = {
  businessName: string;
  firstName: string;
  firstLastName: string;
  secondLastName: string;
};

/**
 * Resolves the human-readable name of an invoice data record.
 *
 * Persona moral records carry the `businessName`; persona física records leave it empty
 * (the form clears it explicitly), so the name falls back to the person's full name in
 * Spanish order: `firstName firstLastName secondLastName`. Empty parts are dropped, so a
 * record without `secondLastName` renders as "ADRIANA JUAREZ".
 *
 * @param invoiceData - Invoice data name fields, or `null`/`undefined` when the block has none
 * @returns The business name, the composed person name, or an empty string
 */
export const getInvoiceDisplayName = (invoiceData?: InvoiceNameParts | null): string => {
  if (!invoiceData) return '';
  if (invoiceData.businessName?.trim()) return invoiceData.businessName;

  return [invoiceData.firstName, invoiceData.firstLastName, invoiceData.secondLastName]
    .map((part) => part?.trim())
    .filter(Boolean)
    .join(' ');
};
